module.exports = __webpack_public_path__ + "static/media/Estefania_Monterrosas_Sanchez.e6f56c75.png";